import * as angular from "angular";
import {IWindowService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {VisitPlanFilterStateModel} from "../models/visit-plan-filter-state.model";

const VISIT_PLAN_FILTERS_STORAGE_KEY = 'visitPlanFiltersContext';

export class VisitPlanFilterSettingsService {

  constructor(private $window: IWindowService, private splitService: SplitService) {
  }

  getFilters(): VisitPlanFilterStateModel | undefined {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem(VISIT_PLAN_FILTERS_STORAGE_KEY));
    return context && context[siteId] ? context[siteId] : undefined;
  }

  setFilters(filters: VisitPlanFilterStateModel) {
    const siteId = this.splitService.getSiteId();
    let context = angular.fromJson(this.$window.localStorage.getItem(VISIT_PLAN_FILTERS_STORAGE_KEY));

    if (!context) {
      context = {};
    }

    context[siteId] = filters;
    this.$window.localStorage.setItem(VISIT_PLAN_FILTERS_STORAGE_KEY, angular.toJson(context));
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .service('visitPlanFilterSettingsService', VisitPlanFilterSettingsService);
